import type { I18nDictionary } from './types';

type RootDictionary = I18nDictionary | Record<string, I18nDictionary>;

export const getTranslationValue = (dictionary: RootDictionary | undefined, key: string): string | undefined => {
  if (!dictionary) {
    return undefined;
  }

  const path = key.split('.');
  let current: I18nDictionary | string | undefined = dictionary;

  for (const segment of path) {
    if (!current || typeof current === 'string') {
      return undefined;
    }

    current = current[segment];
  }

  return typeof current === 'string' ? current : undefined;
};
